exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body{\n  width:90%;\n  margin: 0 auto;\n  background-color: rgb(53, 54, 53);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./canbas/src/canbas.css
// module id = 6
// module chunks = 0